module.exports = __webpack_public_path__ + "img/illustration-forgot-password-dark.876315b0.jpg";